import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36950207"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { class: "h-3rem sm:h-5rem sm:border-bottom-1 border-gray-400 border-bottom-none" }
const _hoisted_3 = { class: "wp1200 flex sm:align-items-center align-items-end h-full" }
const _hoisted_4 = { class: "text-base font-semibold mt-1 hidden sm:block" }
const _hoisted_5 = { class: "text-base font-semibold mt-1 sm:hidden" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-column gap-4 wp1200 py-4"
}
const _hoisted_7 = { class: "flex-column gap-4 hidden sm:flex" }
const _hoisted_8 = { class: "flex gap-2 align-items-center" }
const _hoisted_9 = { class: "text-primary-600 font-semibold mt-1" }
const _hoisted_10 = { class: "text-2xl my-0" }
const _hoisted_11 = { class: "grid mt-1" }
const _hoisted_12 = { class: "sm:col flex flex-column gap-3 flex-order-1 sm:flex-order-0 col-12" }
const _hoisted_13 = { class: "flex flex-column gap-1 border-round-3xl w-full border-1 border-gray-200 px-4 py-3" }
const _hoisted_14 = { class: "font-semibold text-base mb-1" }
const _hoisted_15 = {
  key: 0,
  class: "flex gap-2 align-items-center text-sm text-gray-800"
}
const _hoisted_16 = { class: "mt-1" }
const _hoisted_17 = { class: "flex gap-2 align-items-center text-sm text-gray-800" }
const _hoisted_18 = { class: "mt-1" }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 4,
  class: "flex gap-2 justify-content-center"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 5,
  class: "bg-primary-50 border-round-2xl p-4 mt-4"
}
const _hoisted_24 = { class: "text-primary-600 font-semibold text-base" }
const _hoisted_25 = { class: "flex align-items-center gap-2 my-2 text-primary-600 text-sm" }
const _hoisted_26 = { class: "mt-1" }
const _hoisted_27 = { class: "text-base mb-0" }
const _hoisted_28 = { class: "col flex flex-column gap-3 flex-order-0 sm:flex-order-1" }
const _hoisted_29 = { class: "h-30rem" }
const _hoisted_30 = { class: "map-container" }
const _hoisted_31 = { class: "popover-content" }
const _hoisted_32 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_FeedbackTypeIcon = _resolveComponent("FeedbackTypeIcon")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_IconMapPin = _resolveComponent("IconMapPin")!
  const _component_IconCalendarEvent = _resolveComponent("IconCalendarEvent")!
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: { name: 'PublicFeedback' },
          class: "flex align-items-center gap-4 no-underline text-gray-900"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowLeft),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("public_feedback.back")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.feedback?.title), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.feedback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_FeedbackTypeIcon, {
                type: _ctx.feedback.type?.name ?? null
              }, null, 8, ["type"]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.feedbackLocale), 1)
            ]),
            _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.feedback.title), 1),
            _createVNode(_component_Divider, { class: "my-0" })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("public_feedback.feedback")), 1),
                (_ctx.feedback.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_IconMapPin),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.feedback.address), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_IconCalendarEvent),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("public_feedback.published")) + ": " + _toDisplayString(_ctx.$moment(_ctx.feedback.time).format("DD.MM.YYYY")), 1)
                ]),
                _createVNode(_component_Divider, { class: "my-1" }),
                _createElementVNode("p", {
                  class: _normalizeClass(["text-gray-900 text-base my-2 feedback-description", { clamped: !_ctx.showFullDescription }]),
                  ref: "descRef"
                }, _toDisplayString(_ctx.feedback.description), 3),
                (_ctx.shouldShowToggle)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "text-gray-800 bg-transparent border-none cursor-pointer text-left px-0 text-base mb-2",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDescription && _ctx.toggleDescription(...args)))
                    }, _toDisplayString(_ctx.$t("public_feedback.show_more")), 1))
                  : _createCommentVNode("", true),
                (_ctx.feedback.image_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      src: _ctx.feedback.image_url,
                      alt: "",
                      class: "w-full border-round-lg my-2",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedImage = _ctx.feedback.image_url))
                    }, null, 8, _hoisted_19))
                  : _createCommentVNode("", true),
                (_ctx.feedback.image_urls && _ctx.feedback.image_urls?.length > 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 3,
                      src: _ctx.feedback.image_urls[_ctx.imageIndex].url,
                      alt: "",
                      class: "w-full border-round-lg my-2 h-20rem",
                      style: {"object-fit":"cover"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedImage = _ctx.feedback.image_urls[_ctx.imageIndex].url))
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true),
                (_ctx.feedback.image_urls && _ctx.feedback.image_urls?.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedback.image_urls, (image, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: index,
                          onClick: ($event: any) => (_ctx.imageIndex = index),
                          class: _normalizeClass(["border-circle border-none cursor-pointer", {
                  'bg-primary-600': _ctx.imageIndex === index,
                  'bg-gray-200': _ctx.imageIndex !== index,
                }]),
                          style: {"width":"12px","height":"12px"}
                        }, null, 10, _hoisted_22))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.feedback.published_message)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("public_feedback.answer")), 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_IconCalendarEvent),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("public_feedback.completed")) + ": " + _toDisplayString(_ctx.$moment(_ctx.feedback.published_message?.created_at).format(
                      "DD.MM.YYYY",
                    )), 1)
                      ]),
                      _createVNode(_component_Divider, { class: "my-2" }),
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.feedback.published_message?.text), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Map, {
                    markers: _ctx.marker,
                    center: _ctx.center,
                    zoom: _ctx.zoom,
                    onCenterChanged: _ctx.updateCenter,
                    onZoomChanged: _ctx.updateZoom
                  }, null, 8, ["markers", "center", "zoom", "onCenterChanged", "onZoomChanged"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedImage)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "body"
        }, [
          _createElementVNode("div", {
            class: "image-popover",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedImage = null))
          }, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("img", {
                src: _ctx.selectedImage,
                alt: ""
              }, null, 8, _hoisted_32)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}